import React from "react";

/**
 * A CSS-only phone mockup frame. Children are rendered inside the "screen".
 */
export default function PhoneMockup({ children, className = "", ...rest }) {
    return (
        <div
            className={`phone-frame ${className}`}
            data-testid={rest["data-testid"] || "phone-mockup"}
        >
            <div className="phone-screen">{children}</div>
        </div>
    );
}
